var _style, _path, _path2, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoClear(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 6048 1656",
    style: {
      enableBackground: "new 0 0 6048 1656"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#FFFFFF;stroke-miterlimit:10;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#77BD22;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 1-invert") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2936.4,1153.8c-45.8,27.9-79.8,48.5-87.4,53c-21.1,12.4-48.8-1.3-48.8-29.5V626.8c0-25.6,25.1-44.6,49.8-29.7 c5.4,3.3,39.6,24.1,86.4,52.7V1153.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3126.6,1037.8c-45.2,27.6-92.9,56.7-136.2,83.2V682.7l136.2,83.1V1037.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3300.3,931.5c-8,5-57,35-119.7,73.3v-206c60.8,37.1,108.9,66.5,119.7,73.1 C3322.5,885.4,3322.1,917.8,3300.3,931.5L3300.3,931.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo--sub"
  }, /*#__PURE__*/React.createElement("path", {
    id: "letter-i",
    className: "st1",
    d: "M65.7,228.8c-25.1-25.1-37.6-54.9-37.6-89.5s12.5-64.5,37.6-89.5c25.1-25.1,54.9-37.6,89.5-37.6 s64.5,12.5,89.5,37.6c25.1,25.1,37.6,54.9,37.6,89.5s-12.5,64.5-37.6,89.5c-25.1,25.1-54.9,37.6-89.5,37.6S90.8,253.8,65.7,228.8z  M253.7,1371.1H53.2V418.5h200.5V1371.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "letter--s",
    className: "st1",
    d: "M839.2,284.3c-61.5,0-111.9,12.5-151.3,37.6s-59.1,63-59.1,113.7s19.7,89.5,59.1,116.4 c39.4,26.9,123.2,55.8,251.6,86.8c128.3,31.1,225,74.6,290.1,130.7s97.6,138.7,97.6,248c0,109.2-41.2,197.9-123.6,265.9 s-190.4,102-324.1,102.1c-195.8,0-369.5-67.4-521.1-202.3L491,1023.8c126.5,109.8,257.8,164.8,393.9,164.7c68,0,122-14.6,162-43.9 c40-29.2,60-68,60-116.4c0-48.3-18.8-85.9-56.4-112.8c-37.6-26.9-102.4-51.3-194.3-73.5c-92-22.1-161.8-42.4-209.5-60.9 s-90.1-42.7-127.1-72.5c-74-56.1-111-142-111-257.9s42.1-205,126.2-267.7c84.2-62.7,188.3-94,312.5-94c80,0,159.3,13.1,238.2,39.4 s146.8,63.3,204.1,111l-112.8,159.4c-37-33.4-87.1-60.9-150.4-82.4S900.7,284.2,839.2,284.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "letter--p",
    className: "st1",
    d: "M1958.3,404.2c127.7,0,236.9,44.2,327.7,132.5s136.1,205.9,136.1,352.7 s-45.1,266.2-135.2,358.1c-90.1,91.9-195.2,137.9-315.1,137.9c-120,0-227.7-52.5-323.2-157.6v416H1448V418.5h200.6V585 C1727.3,464.5,1830.6,404.2,1958.3,404.2z M1645,896.6c0,90.8,27.5,165.1,82.4,222.9s121.8,86.8,200.5,86.8 c78.8,0,147.4-28.7,205.9-86s87.7-131.6,87.7-222.9s-28.7-167.1-86-227.4c-57.3-60.3-126-90.4-205.9-90.4 c-80,0-147.4,30.1-202.3,90.4C1672.4,730.4,1645,805.9,1645,896.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "letter--t",
    className: "st1",
    d: "M3786.5,579.7v483.4c0,45.4,11.9,81.5,35.8,108.3c23.9,26.8,57.3,40.3,100.3,40.3 s84.2-20.9,123.6-62.7l82.4,141.4c-70.4,63.3-148.3,94.9-233.6,94.9s-158.2-29.6-218.5-88.6c-60.3-59.1-90.4-138.8-90.4-239V119.5 h200.6v299h250.7v161.2H3786.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "letter--dot",
    className: "st1",
    d: "M4299.5,1346.1c-25.7-26.2-38.5-57.9-38.5-94.9s12.8-68.4,38.5-94c25.6-25.7,57-38.5,94-38.5 s68.7,12.8,94.9,38.5c26.2,25.7,39.4,57,39.4,94s-13.1,68.6-39.4,94.9s-57.9,39.4-94.9,39.4S4325.2,1372.3,4299.5,1346.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "letter--tv",
    className: "st1",
    d: "M5812.2,418.5l-290.1,719.8L5232,418.5h-391.8v-299h-200.5v938.3c0,100.3,30.1,179.9,90.4,239 s133.1,88.6,218.5,88.6c85.3,0,163.2-31.6,233.7-94.9l-82.4-141.4c-39.4,41.8-80.6,62.7-123.5,62.7c-43,0-76.4-13.4-100.3-40.3 c-23.9-26.8-35.8-63-35.8-108.3V579.7h248.9l318.4,791.4h229.2L6020,418.5L5812.2,418.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "letter--o",
    className: "st2",
    d: "M3002.6,414.9c-268.8,0-486.8,217.9-486.8,486.8s217.9,486.8,486.8,486.8 s486.8-217.9,486.8-486.8S3271.4,414.9,3002.6,414.9z M2936.4,1153.8c-45.8,27.9-79.8,48.5-87.4,53c-21.1,12.4-48.8-1.3-48.8-29.5 V626.8c0-25.6,25.1-44.6,49.8-29.7c5.4,3.3,39.6,24.1,86.4,52.7V1153.8z M3126.6,1037.8c-45.2,27.6-92.9,56.7-136.2,83.2V682.7 l136.2,83.1V1037.8z M3300.3,931.5c-8,5-57,35-119.7,73.3v-206c60.8,37.1,108.9,66.5,119.7,73.1 C3322.5,885.4,3322.1,917.8,3300.3,931.5L3300.3,931.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoClear);
export default __webpack_public_path__ + "static/media/LogoClear.47df4a9b73c0e09c0ab8a8a42123bed4.svg";
export { ForwardRef as ReactComponent };